export const DEFAULT_RETURN_URL = "https://redacamy.org/learner/courses";
const RETURN_URL_PREFIX = "spiritual-profile-platform-return-url:";

export const isAllowedReturnUrl = (value) => {
  try {
    const url = new URL(value);
    return url.protocol === "https:" && (url.hostname === "redacamy.org" || url.hostname.endsWith(".redacamy.org"));
  } catch {
    return false;
  }
};

// Remembered per profile, so launching a different course never sends the user to the wrong page.
export const rememberReturnUrl = (profileId, search) => {
  const candidate = new URLSearchParams(search).get("return_url");
  if (!profileId || !candidate || !isAllowedReturnUrl(candidate)) return;
  try {
    window.sessionStorage.setItem(`${RETURN_URL_PREFIX}${profileId}`, candidate);
  } catch {
    // Without storage the button simply does not appear.
  }
};

export const getReturnUrl = (profileId) => {
  try {
    const value = window.sessionStorage.getItem(`${RETURN_URL_PREFIX}${profileId}`);
    return value && isAllowedReturnUrl(value) ? value : null;
  } catch {
    return null;
  }
};
